module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      D.H. Lawrence\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in England on September 11, 1885, D. H. Lawrence is regarded as one of the most influential writers of the twentieth century. Lawrence published many novels and poetry volumes during his lifetime, including Sons and Lovers and Women in Love, but is best known for his infamous novel Lady Chatterley’s Lover. The graphic and highly sexual novel was published in Italy in 1928, but was banned in the United States until 1959, and banned in England until 1960. Garnering fame for his novels and short stories early into his career—especially his collections "), _c('I', [_vm._v("The Fox, The Captain’s Doll, and The Ladybird")]), _vm._v(" and "), _c('I', [_vm._v("The Prussian Officer and Other Stories")]), _vm._v("—Lawrence later received acclaim for his personal letters and poetry, in which he detailed a range of emotions, from exhilaration to depression to prophetic brooding. He died in France in 1930.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17Ib9Oe/tc-custom/9780795351570.jpg?1696637178129",
      "alt": "This image is the cover for the book Sketches of Etruscan Places"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sketches of Etruscan Places\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("From the author of "), _c('i', [_vm._v("The Rainbow")]), _vm._v(", a travelogue of his journey through central Italy during the reign of Mussolini.")])]), _vm._v(" Written in 1927 after visiting several Etruscan cities in central Italy, six of the seven essays contained in "), _c('i', [_vm._v("Sketches of Etruscan Places ")]), _vm._v("were posthumously published in 1932. The seventh, “The Florence Museum” is published here for the first time, along with forty-five illustrations reproduced with D. H. Lawrence’s own captions. The second part of this volume contains eight additional essays about Florence and the Tuscan countryside.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    RosettaBooks LLC\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0